import { ReactNode, ButtonHTMLAttributes, DetailedHTMLProps } from "react";
import { LinkProps } from "next/link";
import { UrlObject } from "url";

export enum TAG_SIZE {
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small",
}

export enum TAG_COLOR {
  DEFAULT = "default",
  BRAND = "brand",
}

export enum TAG_STYLE {
  FILL = "fill",
  LIGHT = "light",
  OUTLINE = "outline",
}

export enum TAG_STATUS {
  DEFAULT = "default",
  HOVER = "hover",
  SELECTED = "selected",
  DISABLE = "disable",
}
export enum TAG_TYPE {
  ROUNDED = "rounded",
  SQUARE = "square",
}

type ButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

export interface BaseTagProps {
  style?: TAG_STYLE;
  size?: TAG_SIZE;
  color: TAG_COLOR;
  type: TAG_TYPE;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  className?: string;
  showTagClose?: boolean;
  handleCloseClick?: () => void;
  select?: boolean;
  disableActiveClass?: boolean;
}

export interface LinkTagProps extends BaseTagProps, LinkProps {
  href: UrlObject | string;
  target?: string;
  children?: ReactNode;
}

export interface ButtonTagProps
  extends BaseTagProps,
    Omit<ButtonProps, "color" | "style" | "type"> {
  href?: undefined;
  children?: ReactNode;
}

export type TagProps = LinkTagProps | ButtonTagProps;

export interface TagContentProps {
  size: TAG_SIZE;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  showTagClose?: boolean;
  handleCloseClick?: () => void;
  children?: ReactNode;
}
